export const notificationConstants = {
    NOTIFICATION_POPUP: 'NOTIFICATION_POPUP',
    NOTIFICATION_CLEAR: 'NOTIFICATION_CLEAR',
}